import { localeRequestHeaders } from './localePreference';

export async function getNetworkingRecommendations({ user, prepare = false, signal }) {
  const token = await user.getIdToken();
  const response = await fetch('/api/v1/networking/recommendations', {
    method: prepare ? 'POST' : 'GET', signal,
    headers: { Authorization: `Bearer ${token}`, ...localeRequestHeaders() },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error('Couldn’t load your networking recommendations. Please try again.');
  return payload;
}
